module.exports = __webpack_public_path__ + "img/step1.55a8fb76.png";